import Box from '@mui/material/Box'
import { CSSProperties, ReactNode } from 'react'

interface Props {
  children: ReactNode
  style?: CSSProperties
}

export default function ShiftLabelComponent(props: Props) {
  return (
    <Box
      style={{
        ...labelStyle,
        ...props.style,
      }}
    >
      {props.children}
    </Box>
  )
}

const labelStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '32px',
  width: '88px',
  borderRadius: '8px',
  textAlign: 'center',
  padding: '0 4px',
}
